/**
 * Mega Menu
 * @class rlMegaMenu
 * @memberOf jQuery.fn
 */


(function($) {
    $.fn.rlMegaMenu = function() {
        // Sticky header stuff
        // Hide Header on scroll down
        var didScroll;
        var lastScrollTop = 0;
        var navbarHeight = $('#header').outerHeight();

        function checkMarginTop() {
            const windowwidth = window.innerWidth,
                headerheight = Math.round($('#header').outerHeight()),
                header_smlmobile = 69,
                header_stdmobile = 75,
                header_tablet = 79,
                header_large = 216,
                header_xlarge = 212;
            //header_... variable numbers are taken from default html margin-top set in the layout.sass file!

            function addheaderheight($element, $attribute) {
               $($element).css($attribute, headerheight);
            }
            function removeheaderheight($element) {
              $($element).removeAttr('style');
            }

            // epi-preview mode.
           if ($('html').hasClass('epi-preview') && !$('html').hasClass('StaticHeader') && !$('html').hasClass('yourplan')) {
               if (windowwidth <= 350 && headerheight != header_smlmobile) {
                  addheaderheight('main.main-content','padding-top');
               }
               else if (windowwidth > 350 && windowwidth < 768 && headerheight != header_stdmobile) {
                  addheaderheight('main.main-content', 'padding-top');
               }
               else if (windowwidth >= 768 && windowwidth < 991 && headerheight != header_tablet) {
                  addheaderheight('main.main-content', 'padding-top');
               }
               else if (windowwidth >= 992 && windowwidth < 1199 && headerheight != header_large) {
                  addheaderheight('main.main-content', 'padding-top');
               }
               else if (windowwidth >= 1200 && headerheight != header_xlarge) {
                  addheaderheight('main.main-content', 'padding-top');
               }
               else {
                  removeheaderheight('main.main-content');
               }
            }
            else if (!$('.standardPage').hasClass('campaignPage') && !$('#header').hasClass('nav-squeeze')) {
              
              if (windowwidth <= 350 && headerheight != header_smlmobile) {
                 addheaderheight('html','margin-top');
              }
              else if (windowwidth > 350 && windowwidth < 768 && headerheight != header_stdmobile) {
                 addheaderheight('html', 'margin-top');
              }
              else if (windowwidth >= 768 && windowwidth < 991 && headerheight != header_tablet) {
                 addheaderheight('html', 'margin-top');
              }
              else if (windowwidth >= 992 && windowwidth < 1199 && headerheight != header_large) {
                 addheaderheight('html', 'margin-top');
              }
              else if (windowwidth >= 1200 && headerheight != header_xlarge) {
                 addheaderheight('html', 'margin-top');
              }
              else {
                 removeheaderheight('html');
              }
           }        
       }

       var RecheckMarginTop;
       RecheckMarginTop = (function () {

          let stateCheck = setInterval(() => {
             if (document.readyState === 'complete') {
                clearInterval(stateCheck);

                elem = document.getElementById("main-content");
                let resizeObserver = new ResizeObserver(() => {
                   checkMarginTop();
                });
                resizeObserver.observe(elem);
             }
          }, 250);
       });

       if (!$('html').hasClass('StaticHeader')) {
          RecheckMarginTop();
       }

       // omit sticky header in iframe (episerver-preview)
       if (inIframe() && !$('html').hasClass('StaticHeader') && !$('html').hasClass('yourplan')) {
          $('html').addClass('epi-preview');
       }
       else {
          $(document).scroll(function (event) {
             didScroll = true;
          });
          setInterval(function () {
             if (didScroll && !$('html, body').hasClass('mob-menu-open')) {
                hasScrolled();
                didScroll = false;
             }
          }, 250);
       }

        function hasScrolled() {
            var st = $(this).scrollTop();
            var scrollInterval = 99;
            // set the scroll interval to fire alot more while in the header to minimise delay causing whitespace
            if (st < navbarHeight) {
                var scrollInterval = 10;
            }
            // Make sure they scroll more than fromTop
            if (Math.abs(lastScrollTop - st) <= scrollInterval)
                return;

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop) {
                // Scroll Down
                $('#header').removeClass('nav-down').addClass('nav-up');
            } else if (st + $(window).height() - 450 < $(document).height()) {
                // Scroll Up
                //bring the nav back down
                $('#header').removeClass('nav-up').addClass('nav-down');
                $('#header').addClass('nav-squeeze');
            }
            if (st < (navbarHeight - 50)) {
                // full nav to come back when at top of page
                $('#header').removeClass('nav-up').addClass('nav-down');
                $('#header').removeClass('nav-squeeze');
            }
            lastScrollTop = st;
        }

        ////////////////////////////////////////
        /////////////LEVEL ONE//////////////////
        ////////////////////////////////////////

        //variables
        var level1arrow = $('.nav-item.level1 .arrow.level1'), //used on mobile viewports
            level1link = $('.nav-item.level1 .nav-link.level1'), //used in desktop viewports
            level1item = $('.nav-item.level1'), //used on hoverintent (parent of two elements listed above)
            level2arrow = $('.nav-item.level1 .arrow.level2'), //used on mobile viewports
            level1megamenu = $('.nav-item.level1 .navbar-megamenu'),
            yourPlanMobile = false;

        //match the height of level1 nav elements
        $('#header .nav-item.level1 .arrow.level1, #header .nav-item.level1 .nav-link.level1').matchHeight();

        $(".navbar-nav.level2 .nav-item .nav-link").each(function() {
            if ($(this).next('.arrow').length > 0) {
                $(this).addClass('hasarrow');
            }
        });

        //level 1 link on focus
        level1link.on('focusin', function () {

            level1megamenu.removeClass('show');
            level1link.next('.navbar-megamenu').find('a, button').attr('tabindex', '-1');

            if (level1link.parent('.nav-item').hasClass('active')) {
                level1link.attr("aria-expanded", "false");
            }

            level1link.parent('.nav-item').removeClass('active');
            $(this).parent('.nav-item').addClass('active');

        });

        //level 1 click event
        level1link.on('click', function () {
           if (yourPlanMobile === false) {
              level1linkclickevent(this);
           }
           else {
              //Default Behaviour on yourplan mobile/tablet!
           }
        });

        function level1linkclickevent(el) {

            level1link.next('.navbar-megamenu').removeClass('show');
            level1link.parent('.nav-item').removeClass('active');
            level1link.not(el).blur();
            $(el).attr('aria-expanded', 'true');
            $(el).next('.navbar-megamenu').find('a, button').removeAttr('tabindex');
            $(el).next('.navbar-megamenu').addClass('show');
            $(el).parent('.nav-item').addClass('active');

            if (level2arrow.css('display') == 'block') {
               $(el).next('.navbar-megamenu').find('.navbar-nav.level3').hide();
            }
        }

        //custom keyboard mapping for level 1 link
        level1link.on('keydown', function (e) {

            //var keycode = e.which;
            var keycode = (e.keyCode ? e.keyCode : e.which);

           if (yourPlanMobile === false) {
              //spacebar
              if (keycode === 32) {
                 e.preventDefault();
                 level1linkclickevent(this);
              }
              //enter
              else if (keycode === 13) {
                 e.preventDefault();
                 level1linkclickevent(this);
              }
           }
           else {
              //Default Behaviour on yourplan mobile/tablet!
           }
        });

        $('.navbar-megamenu').each(function () {
            $(this).find('.l2.desktop').matchHeight();
        });

        //////////////////////
        //mobile functionality
        //////////////////////

        $('.navbar-nav .arrow.level1').css("left", "0.75rem");

        level1arrow.on('click', function() {
            $(this).toggleClass('active');

            if ($(this).hasClass('active')) {

                resetmm();

                $(this).addClass('active');
                $(this).next('.nav-link').addClass('active').next('.navbar-megamenu').addClass('show');

                var currentnavid = $(this).parent('.nav-item').attr('id');
                var distanceToScroll = $("#" + currentnavid).position().top

                $('.scroll-wrapper').animate({
                    scrollTop: distanceToScroll
                }, 250);
            } else {

                $(this).removeClass('active');
                $(this).attr('aria-expanded', 'false');
                $(this).next('.nav-link').removeClass('active').next('.navbar-megamenu').removeClass('show');
                $('.scroll-wrapper').animate({
                    scrollTop: 0
                }, 250);
            }
            return false;
        });

        ////////////////////////////////////////
        /////////////LEVEL TWO//////////////////
        ////////////////////////////////////////

        //mobile only (level2arrow hidden within sass files on desktop)
        level2arrow.on('click', function () {
            let level3ContainerSelector = $(this).next('.navbar-nav.level3');

            if ($(this).parents('html').hasClass('yourplan')) {
               level3ContainerSelector = $(this).prev('.level3-container');
            }

            $(this).toggleClass('active');

            if ($(this).hasClass('active')) {
                $(this).attr('aria-expanded', 'true');
                level3ContainerSelector.show();
                level3ContainerSelector.addClass('show');
            }
            else {
                $(this).attr('aria-expanded', 'false');
                level3ContainerSelector.hide();
                level3ContainerSelector.removeClass('show');
            }
        });

        //mobile only to open second level menu
        $('.level2nav').on('click', function () {
            level2nav = $(this).next('.nav-item.level1 .arrow.level2');
            level2nav.toggleClass('active');
            if (level2nav.hasClass('active')) {
                level2nav.attr('aria-expanded', 'true');
                level2nav.next('.navbar-nav.level3').show();
                level2nav.next('.navbar-nav.level3').addClass('show');
            } else {
                level2nav.attr('aria-expanded', 'false');
                level2nav.next('.navbar-nav.level3').hide();
                level2nav.next('.navbar-nav.level3').removeClass('show');
            }
        });

        ///////////////////////
        //desktop functionality
        ///////////////////////
        function hoverintentornot() {
            //hoverintent
           level1link.hoverIntent(function () {

              if (yourPlanMobile === false) {
                 level1link.not(this).blur();
                 level1link.attr("aria-expanded", "false");
                 level1item.not(this).blur();
                 level1item.removeClass('active');
                 level1megamenu.removeClass('show');

                 $(this).attr('aria-expanded', 'true');

                 $(this).next('.navbar-megamenu').addClass('show').parent('.nav-item').addClass('active');
                
              }

            });

            var megamenudelay;

            function megamenudelayfunc() {
               megamenudelay = window.setTimeout(
                  function() {

                        $('.navbar-megamenu').removeClass('show');
                        $('.nav-item.level1').removeClass('active');
                        $('.nav-item.level1, .nav-link.level1').blur();
                        $('.nav-link.level1').attr("aria-expanded", "false");

                  }, 1000);
            }
            megamenudelayfunc();
            level1item.on({
               mouseenter: function() {
                  clearTimeout(megamenudelay);
               },
               mouseleave: function() {
                  megamenudelayfunc();
               }
            });
           

            //click on body to close menu

            $('body').bind('click', function(e) {
               if ($(e.target).closest(".navbar-megamenu").length > 0) {
                  //don't close the menu if the click is within a mega menu panel instance
               }
               else if (!level1link.is(":focus")) {
                  level1megamenu.removeClass('show');
                  level1item.removeClass('active');
               }
            });

            //focusout on last item 'active' fix.
            $("#yourplan-header .navbar-nav.level1 .nav-item:last-of-type .nav-link").on("focusout", function (event) {
              $(this).parent().removeClass('active');
            });

            

        }

        //burger menu on mobile
        $('#burger-menu').on('click', function() {
            var scrollWrapper = $('.mainmenu .scroll-wrapper')

            if ($(this).hasClass('collapsed')) {
                resetmm();
            }

            $('html, body').not('html.yourplan, html.yourplan body').toggleClass('mob-menu-open');

            if ($('html, body').hasClass('mob-menu-open')) {
                scrollWrapper
                    .animate({ height: window.innerHeight }, 500, function () {
                        $(this).css({
                           height: window.innerHeight - scrollWrapper.offset().top
                        });
                    });
            } else {
                scrollWrapper.animate({ height: 0 }, 200);
            }

            if (yourPlanMobile) {
               if ($(this).hasClass('is-active')) {
                  $('.header-mainnav a').removeAttr('tabindex').attr('aria-hidden', 'false');
               }
               else {
                  $('.header-mainnav a').attr('tabindex', '-1').attr('aria-hidden', 'true');
               }
            }
        });

        //use close button to close megamenu on desktop
        $("button.close").on('click', function() {
            closebuttonactions(this);
        }).on('keydown', function (e) {
                if (e.keyCode === 32) {
                    $(this).trigger('click');
                }
        });


        ////////////
        //functions
        ///////////
        function inIframe() {
          try {
             return window.self !== window.top;
          } catch (e) {
             return true;
          }
        };
        function yourplanTabIndex() {
          if (yourPlanMobile && $('#burger-menu').css('display') === 'block') {
             $('.header-login a ').attr('tabindex', '-1').attr('aria-hidden', 'true');
          }
          else {
             $('.header-login a').removeAttr('tabindex').attr('aria-hidden', 'false');
          }
          if (yourPlanMobile && $('#burger-menu').css('display') === 'block' && !$('#burger-menu').hasClass('is-active')) {
             $('.header-mainnav a').not('.header-mainnav.show a').attr('tabindex', '-1').attr('aria-hidden', 'true');
          }
          else {
             $('.header-mainnav a').removeAttr('tabindex').attr('aria-hidden', 'false');
          }
        }


        function yourplanMegaMenu() {
           if ($('#yourplan-header').length > 0) {
              yourPlanMobile = true;
           }
           else {
              yourPlanMobile = false;
           }
        }
        function resetmm() {
            level1item.removeClass('active');
            level1arrow.removeClass('active');
            level1link.removeClass('active');
            level1megamenu.removeClass('show');

            level2arrow.removeClass('active');
            level2arrow.next('.navbar-nav.level3').removeClass('show');
        };

        function resetMenu() {
            $('html, body').removeClass('mob-menu-open');
        }
        function resetburger() {
            $('#burger-menu').removeClass('is-active');
            $('.navbar-collapse').removeClass('show');
        }

        function dueluser() {
            //Are you a duel main nav user?
            if ($('.logo-sm').css('display') === 'block') {
                $('.logo-sm').parent('a').parent('.header__site-logo').addClass('mobileuser');
            } else if ($('.logo-lg').css('display') === 'block') {
                $('.logo-lg').parent('a').parent('.header__site-logo').addClass('desktopuser');
            }
        }
        function closebuttonactions(element) {
            $(element).parents(".navbar-megamenu").removeClass("show");
            level1link.attr("aria-expanded", "false");
            setTimeout(function () {
                $(element).parents(".navbar-megamenu").siblings(level1link).focus();
            }, 200); 
        }

        //initialise on doc ready
        checkMarginTop();
        hoverintentornot();
        dueluser();
        resetMenu();
        yourplanMegaMenu();
        yourplanTabIndex();
        //retrigger appropriate functions on window resize
        $(window).on('resize-end', function() {
            checkMarginTop();
            hoverintentornot();
            yourplanTabIndex();
            dueluser();
            if ($('.header__site-logo').hasClass('mobileuser') && $('.header__site-logo').hasClass('desktopuser')) {
                resetmm();
                resetburger();
                resetMenu();
            }
        });
    }
}(jQuery));
